import Box from "@cloudscape-design/components/box"
import Button from "@cloudscape-design/components/button"
import SpaceBetween from "@cloudscape-design/components/space-between"
import { useNavigate } from "react-router-dom"

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <Box textAlign="center" padding={{ top: "xxxl", bottom: "xxxl" }}>
      <SpaceBetween size="m">
        {/* display-l is Cloudscape's largest font-size token; the hero 404 needs a
            larger size than any token provides, so it uses an inline fontSize. */}
        <Box
          variant="h1"
          fontSize="display-l"
          color="text-status-info"
          fontWeight="bold"
          padding="n"
        >
          <span style={{ fontSize: "5rem", lineHeight: 1 }}>404</span>
        </Box>
        <Box variant="h1" fontSize="heading-xl">
          Page Not Found
        </Box>
        <Box variant="p" fontSize="heading-s" color="text-body-secondary">
          The page you're looking for doesn't exist.
        </Box>
        <Box>
          <Button variant="primary" onClick={() => navigate("/")}>
            Go back home
          </Button>
        </Box>
      </SpaceBetween>
    </Box>
  )
}

export default NotFound
